import {
  Button,
  Divider,
  Grid,
  Typography,
} from "@mui/material";

import Section from "./components/Section";
import DetailGrid from "./components/DetailGrid"
import GlobalProgrammaticMarginForm from "./forms/GlobalProgrammaticMarginForm";
import GlobalProgrammaticMarginHistoryList from "./GlobalProgrammaticMarginHistoryList";

import formatNumber from "../../utils/formatNumber.js";
import formatDateTimeString from "../../utils/formatDateTimeString.js";
import { useState } from "react";

const getDetailGridProps = ({ name, reserved_margin, isEditing, formProps }) => {
  const type = name === "reserved_margin" ? "fullscreen" : "banner"
  const firstColumn = {
    title: "Current Margin (%)",
    description: (!isEditing ? formatNumber(reserved_margin, { style: "percent" }) : (
      <GlobalProgrammaticMarginForm name={name} reservedMargin={reserved_margin} {...formProps} />
    ))
  }

  const props = {
    PaperProps: { sx: { backgroundColor: "white" } },
    disableBadge: true,
    columns: [
      firstColumn,
      { title: "Description", description: `Applies a global margin on all incoming ${type} bids for third-party programmatic demand` }
    ]
  }

  return props
}

const EditButton = ({ onClick }) => (
  <Button sx={{ alignSelf: "self-end" }} variant="contained" size="small" onClick={onClick}>Edit</Button>
)

const ShowMore = ({ onClick: handleClick, expanded }) => {

  return (
    <Button onClick={handleClick} size="small" variant="outlined" sx={{ marginLeft: 2 }}>
      {!expanded ? "Show" : "Hide"} History
    </Button>
  )
}

const GlobalProgrammaticMarginSection = ({ name, title, value, updated_at, updated_by, children }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [showHistory, setShowHistory] = useState(false);

  const handleEditClick = (event) => setIsEditing((prev) => !prev);
  const hideEditForm = () => setIsEditing(false);

  return (
    <Section title={title} actionButton={<EditButton onClick={handleEditClick} />}>
      <Grid container item xs={12}>
        <Grid item xs={12} sx={{ borderRadius: 2, display: "flex", flexDirection: "row" }}>
          <DetailGrid
            {...getDetailGridProps({ name, isEditing, reserved_margin: value, formProps: { onCancel: hideEditForm } })}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} rowSpacing={3}>
        <Grid item xs={12}>
          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle1" sx={{ flexDirection: "row", color: "rgb(0,0,0,0.60)" }}>Last modified</Typography>
          <Typography component="div" variant="body2" sx={{ flexDirection: "row" }}>
            {formatDateTimeString(updated_at)}{updated_by && ` by ${updated_by}`}<ShowMore expanded={showHistory} onClick={(e) => setShowHistory(v => !v)} />
          </Typography>
        </Grid>
        {showHistory && (
          <Grid item xs={12}>
            <GlobalProgrammaticMarginHistoryList name={name} />
          </Grid>
        )}
      </Grid>
    </Section>
  )
}

export default GlobalProgrammaticMarginSection;
